import React, { useEffect, useState } from 'react';
import { isArray } from 'lodash';

const CustomTable = (props) => {
    const { handleChange, data, columns, checkbox = false, selectedStbId = [], valueKey } = props;

    const [colList, setColList] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const [sortedData, setSortedData] = useState(data);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    // const [colKeyList, setColKeyList] = useState([]);
    // const [isSelectAll, setIsSelectAll] = useState(false);

    useEffect(() => {
        setSortedData(data);
    }, [data]);

    useEffect(() => {
        const title = [];
        const key = [];
        if(selectedStbId.length <= 0){
            setIsChecked(false)
        }
        isArray(columns) && columns.forEach(element => {
            key.push(element.key);
            title.push(element.text);
        });
        setColList(title);
        // setColKeyList(key);

    }, [data, columns, selectedStbId]);

    const sortData = (key, direction) => {
        const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    
        const sorted = [...data].sort((a, b) => 
            collator.compare(a[key].toString(), b[key].toString()) * (direction === 'asc' ? 1 : -1)
        );
    
        setSortConfig({ key, direction });
        setSortedData(sorted);
    };

    const showColumns = () => {
        const selectAll = (<td>
            <div className='select-all-wrap'>Select All </div>
            <label >
                <input id='SelectAllCheckbox' type="checkbox" name="" onChange={e => handleSelectAll(e)} checked={ isChecked && selectedStbId.length > 0 }/>
            </label>
        </td>)
       const columnsWithSorting = colList.map((item, index) => {
            if(index < 2 ) {
                return (
                    <td
                        key={`${item}-${index}`}
                        className={`column-${index + 1}`}
                    >
                        <span dangerouslySetInnerHTML={{ __html: item }} />
                            <div>
                                <span className={`sort-arrow ${sortConfig.key === columns[index].key && sortConfig.direction === 'asc' && 'up'}`} onClick={() => sortData(columns[index].key,"asc")}>↑</span> 
                                <span className={`sort-arrow ${sortConfig.key === columns[index].key && sortConfig.direction === 'desc' && 'down'}`} onClick={() => sortData(columns[index].key,"desc")}>↓</span>
                            </div>
                    </td> )
            }else{
                return (
                    <td className={`column-${index+1}`} dangerouslySetInnerHTML={{ __html: item }} key={`${item}-${index}`}></td>
                ); 
            }
    });

        checkbox && selectAll ? columnsWithSorting.splice(0, 0, selectAll) : columnsWithSorting.splice(0, 0, '')
        return columnsWithSorting;
    }

    const getRowData = (row, rowIndex) => {

        const rowData = columns.map((item, index) => {
            if (item.formatter)
                return (<td key={`${row[item.key]}-${index}`}> {item.formatter(row[item.key] || '-', row, rowIndex)} </td>)
            else
                return (
                    <td key={`${row[item.key]}-${index}`}>{row[item.key] || '-'}</td>
                )
        })
        checkbox &&
            rowData.splice(0, 0, (<td>
                <label >
                    <input
                        type="checkbox"
                        id={row.subId}
                        name='userList'
                        checked={selectedStbId.includes(row[valueKey]) ? true : false}
                        onChange={(e) => handleChange(e, row, false)} />
                    {/*<span className="che ckmark"></span>*/}
                </label>
            </td>))
        return rowData;
    }
    const fetchTableData = () => {
        const dataTable = isArray(sortedData) && sortedData.map((item, ind) => {
            return (
                <tr key={`key-${ind}`}>
                    {
                        getRowData(item, ind)
                    }
                </tr>
            )

        })
        return dataTable;
    }
    const handleSelectAll = (e) => {
        setIsChecked(!isChecked)
        if (e.target.checked)
            handleChange(e, data, true)
        else
            handleChange(e, [], true)

    }
    // const handleSelect = (e, value) => {
    //     handleChange(e, value)
    // }

    return (<>
        <table className='subscriber-details-table'>
            <thead>
                <tr>
                    {showColumns()}
                </tr>
            </thead>
            <tbody>
                {fetchTableData()}
            </tbody>
        </table>
        {data.length <= 0 && <div className="no-data-found mt30">No data found</div>}
    </>)
}

export default CustomTable;